import API from "@/utils/api";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    nowProcessingSiteWithId: null,
    isFetchedSites: false,
    sites: [],
    site: {},
    savingInProgress: false,
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    addSiteToState(state, data) {
      let object = state.sites;
      object.unshift(data);
      Vue.set(state, "sites", object);
    },
    removeSiteFromState(state, id) {
      let sites = [];
      Object.entries(state.sites).forEach((item) => {
        if (Number(item[1].id) != Number(id)) {
          sites.push(item[1]);
        }
      });
      state.itemsTotalCount--;
      Vue.set(state, "sites", sites);
    },
    updateSiteInState(state, data) {
      let existsAtIndex = state.sites.findIndex((u) => u.id === data.id);
      if (existsAtIndex !== -1) {
        state.sites[existsAtIndex] = data;
      }
      //Clone the array to trigger a UI update
      state.sites = [...state.sites];
    },
  },
  actions: {
    async fetch({ commit, state, dispatch }, payload) {
      updateField(state, { path: "isFetchedSites", value: false });
      return API.get("/sites")
        .then((response) => {
          updateField(state, { path: "sites", value: response.data.data });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "isFetchedSites", value: true });
        });
    },
    async store({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await API.post("/sites", payload)
        .then((response) => {
          if (response.data.data.id > 0) {
            this._vm.$inform(i18n.t("common.success_add"));
            commit("addSiteToState", response.data.data);
            return response.data.data;
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    remove({ commit, state, dispatch }, payload) {
      return API.delete("/sites/" + payload.id)
        .then((response) => {
          if (response.data.status === "success") {
            commit("removeSiteFromState", payload.id);
            this._vm.$inform(i18n.t("common.success_remove"));
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async update({ commit, state, dispatch }, payload) {
      updateField(state, {
        path: "nowProcessingSiteWithId",
        value: payload.id,
      });
      updateField(state, { path: "savingInProgress", value: true });
      return await API.put("/sites/" + payload.id, payload)
        .then((response) => {
          if (
            response.data &&
            response.data.status === "success" &&
            response.data.data
          ) {
            this._vm.$inform(i18n.t("common.operation_success"));
            commit("updateSiteInState", response.data.data);
          }
          return response.data.data;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
          return false;
        })
        .finally(() => {
          updateField(state, { path: "nowProcessingSiteWithId", value: null });
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
  },
};
